import * as React from 'react'
import {
  APPS_ROUTE,
  CREATE_PASSWORD_ROUTE,
  HOMEPAGE_ROUTE,
  LOGIN_ROUTE,
  ORGANIZATIONS_ROUTE,
  RECOVERY_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  UPDATE_PASSWORD_PROFILE_ROUTE,
  UPDATE_PROFILE_ROUTE,
  USERS_ROUTE,
  LOGOUT_ROUTE,
} from 'constantes/routes'

import requireAuth from './requireAuth'
import HomepagePage from '@App/components/pages/HomePage'
import ProfileFormPage from '@App/components/pages/ProfileFormPage'
// import UserFormPage           from '@App/components/pages/UserFormPage'
import UsersPage from '@App/components/pages/UsersPage'
import ApplicationsPage from '@App/components/pages/ApplicationsPage'
import OrganizationsPage from '@App/components/pages/OrganizationsPage'
import RegeneratePasswordPage from '@App/components/pages/RegeneratePasswordPage'
import BaseLayout from '@App/components/layouts/BaseLayout'
import PageLayout from '@App/components/layouts/PageLayout'
import CreatePasswordPage from '@App/components/pages/CreatePasswordPage'
import ResetPasswordPage from '@App/components/pages/ResetPasswordPage'
import LogInPage from '@App/components/pages/LogInPage'
import RecoveryPassword from '@App/components/pages/RecoveryPasswordPage'
import NotFoundPage from '@App/components/pages/NotFoundPage'
import OrganizationFormPage from '@App/components/pages/OrganizationFormPage'
import RedirectUser from '@App/components/blocks/RedirectUser'

import LogOut from '@App/components/pages/LogOut'

const routes = [
  {
    component: requireAuth({
      ComponentForRender: RedirectUser,
      Layout: PageLayout,
      menuIndex: 0,
    }),
    path: '/connect',
  },
  {
    component: requireAuth({
      ComponentForRender: HomepagePage,
      Layout: PageLayout,
    }),
    path: HOMEPAGE_ROUTE,
  },
  {
    component: () => (
      <BaseLayout>
        <LogInPage />
      </BaseLayout>
    ),
    path: LOGIN_ROUTE,
  },
  {
    component: requireAuth({
      ComponentForRender: ProfileFormPage,
      Layout: PageLayout,
    }),
    path: UPDATE_PROFILE_ROUTE,
  },
  {
    component: () => (
      <BaseLayout>
        <CreatePasswordPage />
      </BaseLayout>
    ),
    path: CREATE_PASSWORD_ROUTE,
  },
  {
    component: () => (
      <BaseLayout>
        <ResetPasswordPage />
      </BaseLayout>
    ),
    path: RESET_PASSWORD_ROUTE,
  },
  {
    component: () => (
      <BaseLayout>
        <RecoveryPassword />
      </BaseLayout>
    ),
    path: RECOVERY_PASSWORD_ROUTE,
  },
  {
    component: requireAuth({
      ComponentForRender: UsersPage,
      Layout: PageLayout,
      // segment: Segments.USERS_READ,
      role: 100,
      menuIndex: 3,
    }),
    path: USERS_ROUTE,
  },
  {
    component: requireAuth({
      ComponentForRender: RegeneratePasswordPage,
      Layout: PageLayout,
    }),
    path: UPDATE_PASSWORD_PROFILE_ROUTE,
  },
  // {
  //   component: requireAuth({
  //     ComponentForRender: UserFormPage,
  //     Layout: PageLayout,
  //     segment: Segments.USERS_WRITE,
  //     menuIndex: 3,
  //   }),
  //   path: `${USERS_ROUTE}/:id/edit`,
  // },
  // {
  //   component: requireAuth({
  //     ComponentForRender: UserFormPage,
  //     Layout: PageLayout,
  //     segment: Segments.USERS_WRITE,
  //     menuIndex: 3,
  //   }),
  //   path: `${USERS_ROUTE}/create`,
  // },
  {
    component: requireAuth({
      ComponentForRender: ApplicationsPage,
      Layout: PageLayout,
      role: 100,
      menuIndex: 2,
    }),
    path: APPS_ROUTE,
  },
  {
    component: requireAuth({
      ComponentForRender: OrganizationsPage,
      Layout: PageLayout,
      role: 100,
      menuIndex: 1,
    }),
    path: ORGANIZATIONS_ROUTE,
  },
  {
    component: requireAuth({
      ComponentForRender: OrganizationFormPage,
      Layout: PageLayout,
    }),
    path: `${ORGANIZATIONS_ROUTE}/create`,
  },
  {
    component: requireAuth({
      ComponentForRender: OrganizationFormPage,
      Layout: PageLayout,
    }),
    path: `${ORGANIZATIONS_ROUTE}/edit`,
  },
  {
    component: () => <LogOut />,
    path: LOGOUT_ROUTE,
  },
  {
    component: () => <NotFoundPage />,
    path: '*',
  },
]

export default routes
